import { createContext } from 'react';

const initialSideNavContext = {
  isCompact: false,
  isMobile: false,
  isScrolling: false,
  setScrolling: () => {},
};

export type SideNavContextType = {
  /** If SideNav should float above content  */
  isCompact: boolean;
  /** SideNav mobile state, hidden when closed, full width when open */
  isMobile?: boolean;
  isScrolling: boolean;
  setScrolling: (scrolling: boolean) => void;
};

export const SideNavContext = createContext<SideNavContextType>(initialSideNavContext);
